import {Component} from '@angular/core';
import {ModalRef} from '../modal-ref';

@Component({
    selector: 'app-archived-profile',
    templateUrl: './archived-profile.component.html',
    styleUrls: ['./archived-profile.component.scss'],
    standalone: false
})
export class ArchivedProfileComponent {
    constructor(private modal: ModalRef<void>) {
    }

    close(): void {
        this.modal.close();
    }
}
